import script from "./EmailSignUpView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSignUpView.vue?vue&type=script&setup=true&lang=js"

import "./EmailSignUpView.vue?vue&type=style&index=0&id=193cbcec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193cbcec"]])

export default __exports__